import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE,
  timeout: 15000
})

// 请求拦截器：自动附加 JWT Token
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理响应格式
service.interceptors.response.use(
  response => {
    const res = response.data

    // 仅 code === 200 表示成功
    if (res.code !== 200) {
      // 401 未授权/Token 过期，清除 Token 并跳转登录页
      if (res.code === 401) {
        removeToken()
        router.push('/login')
        Message.error(res.message || '登录已过期，请重新登录')
        return Promise.reject(new Error(res.message || '未授权'))
      }

      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }

    return res.data
  },
  error => {
    // HTTP 层面的错误（如网络异常、401 状态码等）
    if (error.response && error.response.status === 401) {
      removeToken()
      router.push('/login')
      Message.error('登录已过期，请重新登录')
    } else {
      Message.error(error.message || '网络异常，请稍后重试')
    }
    return Promise.reject(error)
  }
)

export default service
